/* tslint:disable */
/* eslint-disable */
/**
 * telemetry/vending_machine/v1/api.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface MachineManagementServiceSendEventToMachineRequest
 */
export interface MachineManagementServiceSendEventToMachineRequest {
    /**
     * 
     * @type {TelemetryvendingMachinev1EventType}
     * @memberof MachineManagementServiceSendEventToMachineRequest
     */
    'eventType'?: TelemetryvendingMachinev1EventType;
}


/**
 * 
 * @export
 * @interface MachineManagementServiceUpdateBeltsCouplingsRequest
 */
export interface MachineManagementServiceUpdateBeltsCouplingsRequest {
    /**
     * 
     * @type {Array<TelemetryvendingMachinev1BeltsCoupling>}
     * @memberof MachineManagementServiceUpdateBeltsCouplingsRequest
     */
    'beltsCouplings'?: Array<TelemetryvendingMachinev1BeltsCoupling>;
}
/**
 * 
 * @export
 * @interface MachineManagementServiceUpdateMachineBlackoutPeriodRequest
 */
export interface MachineManagementServiceUpdateMachineBlackoutPeriodRequest {
    /**
     * 
     * @type {boolean}
     * @memberof MachineManagementServiceUpdateMachineBlackoutPeriodRequest
     */
    'blackoutPeriodEnabled'?: boolean;
    /**
     * 
     * @type {Array<TelemetryvendingMachinev1BlackoutPeriod>}
     * @memberof MachineManagementServiceUpdateMachineBlackoutPeriodRequest
     */
    'blackoutPeriods'?: Array<TelemetryvendingMachinev1BlackoutPeriod>;
}
/**
 * 
 * @export
 * @interface MachineManagementServiceUpdateMachineRequest
 */
export interface MachineManagementServiceUpdateMachineRequest {
    /**
     * 
     * @type {string}
     * @memberof MachineManagementServiceUpdateMachineRequest
     */
    'timezone'?: string;
    /**
     * 
     * @type {string}
     * @memberof MachineManagementServiceUpdateMachineRequest
     */
    'currencyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof MachineManagementServiceUpdateMachineRequest
     */
    'currencySymbol'?: string;
    /**
     * 
     * @type {number}
     * @memberof MachineManagementServiceUpdateMachineRequest
     */
    'currencyDecimalPoint'?: number;
    /**
     * 
     * @type {string}
     * @memberof MachineManagementServiceUpdateMachineRequest
     */
    'pinCode'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MachineManagementServiceUpdateMachineRequest
     */
    'disabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MachineManagementServiceUpdateMachineRequest
     */
    'globalLowStockAlertPercentage'?: number;
    /**
     * 
     * @type {TelemetryvendingMachinev1DefaultBuyPage}
     * @memberof MachineManagementServiceUpdateMachineRequest
     */
    'defaultBuyPage'?: TelemetryvendingMachinev1DefaultBuyPage;
    /**
     * When One-Based Numbering is enabled, the first tray is referred as 1. The selection starts from 1100, and then 1101. Next tray is 1200, 1201 etc.
     * @type {boolean}
     * @memberof MachineManagementServiceUpdateMachineRequest
     */
    'oneBasedNumberingEnabled'?: boolean;
    /**
     * 
     * @type {TelemetryvendingMachinev1SelectionCodeLength}
     * @memberof MachineManagementServiceUpdateMachineRequest
     */
    'selectionCodeLength'?: TelemetryvendingMachinev1SelectionCodeLength;
    /**
     * 
     * @type {boolean}
     * @memberof MachineManagementServiceUpdateMachineRequest
     */
    'shoppingCartDisabled'?: boolean;
    /**
     * If buy page locked, consumer can\'t switch between different screens, e.g. product display or keyboard based. This option is related to default_buy_page.
     * @type {boolean}
     * @memberof MachineManagementServiceUpdateMachineRequest
     */
    'buyPageLocked'?: boolean;
    /**
     * Skip automatic refund. If enabled, the server will not do automatic refund even if the payment gateway supports it and during vend failure.
     * @type {boolean}
     * @memberof MachineManagementServiceUpdateMachineRequest
     */
    'skipAutomaticRefund'?: boolean;
    /**
     * payment_disabled indicates whether the payment gateway is disabled for this vending machine.
     * @type {boolean}
     * @memberof MachineManagementServiceUpdateMachineRequest
     */
    'paymentDisabled'?: boolean;
    /**
     * skip_failure_blocking when enabled, the slot that failed to dispense the item will not be blocked.
     * @type {boolean}
     * @memberof MachineManagementServiceUpdateMachineRequest
     */
    'skipFailureBlocking'?: boolean;
}


/**
 * 
 * @export
 * @interface MachineManagementServiceUpdateMotorCouplingsRequest
 */
export interface MachineManagementServiceUpdateMotorCouplingsRequest {
    /**
     * 
     * @type {Array<TelemetryvendingMachinev1MotorCoupling>}
     * @memberof MachineManagementServiceUpdateMotorCouplingsRequest
     */
    'motorCouplings'?: Array<TelemetryvendingMachinev1MotorCoupling>;
}
/**
 * 
 * @export
 * @interface MediaManagementServiceUpdateScreenSaverRequest
 */
export interface MediaManagementServiceUpdateScreenSaverRequest {
    /**
     * 
     * @type {string}
     * @memberof MediaManagementServiceUpdateScreenSaverRequest
     */
    'duration'?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaManagementServiceUpdateScreenSaverRequest
     */
    'cta'?: string;
}
/**
 * 
 * @export
 * @interface OrganisationSettingsServiceUpdateComboRequest
 */
export interface OrganisationSettingsServiceUpdateComboRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationSettingsServiceUpdateComboRequest
     */
    'internalName'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganisationSettingsServiceUpdateComboRequest
     */
    'displayName'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganisationSettingsServiceUpdateComboRequest
     */
    'price'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganisationSettingsServiceUpdateComboRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganisationSettingsServiceUpdateComboRequest
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {Array<TelemetryvendingMachinev1ComboProduct>}
     * @memberof OrganisationSettingsServiceUpdateComboRequest
     */
    'products'?: Array<TelemetryvendingMachinev1ComboProduct>;
}
/**
 *  - ORDER_STATE_SUCCEEDED: ORDER_STATE_SUCCEEDED means the order is completed successfully  - ORDER_STATE_EXPIRED: ORDER_STATE_EXPIRED means the order is expired, but consumer did not pay  - ORDER_STATE_CANCELLED: ORDER_STATE_CANCELLED means the order is either cancelled by the consumer or cancelled by vending machine without payment  - ORDER_STATE_REFUNDED: ORDER_STATE_REFUNDED means the order is PAID, but the payment is refunded due to different reasons.
 * @export
 * @enum {string}
 */

export const Paymentsqrcodev1OrderState = {
    Unspecified: 'ORDER_STATE_UNSPECIFIED',
    PendingPayment: 'ORDER_STATE_PENDING_PAYMENT',
    Succeeded: 'ORDER_STATE_SUCCEEDED',
    Expired: 'ORDER_STATE_EXPIRED',
    Cancelled: 'ORDER_STATE_CANCELLED',
    Refunded: 'ORDER_STATE_REFUNDED'
} as const;

export type Paymentsqrcodev1OrderState = typeof Paymentsqrcodev1OrderState[keyof typeof Paymentsqrcodev1OrderState];


/**
 * 
 * @export
 * @interface ProductServiceUpdateProductAttributesRequest
 */
export interface ProductServiceUpdateProductAttributesRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductServiceUpdateProductAttributesRequest
     */
    'attribute1'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductServiceUpdateProductAttributesRequest
     */
    'attribute2'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductServiceUpdateProductAttributesRequest
     */
    'attribute3'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductServiceUpdateProductAttributesRequest
     */
    'attribute4'?: string;
}
/**
 * `Any` contains an arbitrary serialized protocol buffer message along with a URL that describes the type of the serialized message.  Protobuf library provides support to pack/unpack Any values in the form of utility functions or additional generated methods of the Any type.  Example 1: Pack and unpack a message in C++.      Foo foo = ...;     Any any;     any.PackFrom(foo);     ...     if (any.UnpackTo(&foo)) {       ...     }  Example 2: Pack and unpack a message in Java.      Foo foo = ...;     Any any = Any.pack(foo);     ...     if (any.is(Foo.class)) {       foo = any.unpack(Foo.class);     }     // or ...     if (any.isSameTypeAs(Foo.getDefaultInstance())) {       foo = any.unpack(Foo.getDefaultInstance());     }   Example 3: Pack and unpack a message in Python.      foo = Foo(...)     any = Any()     any.Pack(foo)     ...     if any.Is(Foo.DESCRIPTOR):       any.Unpack(foo)       ...   Example 4: Pack and unpack a message in Go       foo := &pb.Foo{...}      any, err := anypb.New(foo)      if err != nil {        ...      }      ...      foo := &pb.Foo{}      if err := any.UnmarshalTo(foo); err != nil {        ...      }  The pack methods provided by protobuf library will by default use \'type.googleapis.com/full.type.name\' as the type URL and the unpack methods only use the fully qualified type name after the last \'/\' in the type URL, for example \"foo.bar.com/x/y.z\" will yield type name \"y.z\".  JSON ==== The JSON representation of an `Any` value uses the regular representation of the deserialized, embedded message, with an additional field `@type` which contains the type URL. Example:      package google.profile;     message Person {       string first_name = 1;       string last_name = 2;     }      {       \"@type\": \"type.googleapis.com/google.profile.Person\",       \"firstName\": <string>,       \"lastName\": <string>     }  If the embedded message type is well-known and has a custom JSON representation, that representation will be embedded adding a field `value` which holds the custom JSON in addition to the `@type` field. Example (for message [google.protobuf.Duration][]):      {       \"@type\": \"type.googleapis.com/google.protobuf.Duration\",       \"value\": \"1.212s\"     }
 * @export
 * @interface ProtobufAny
 */
export interface ProtobufAny {
    [key: string]: object | any;

    /**
     * A URL/resource name that uniquely identifies the type of the serialized protocol buffer message. This string must contain at least one \"/\" character. The last segment of the URL\'s path must represent the fully qualified name of the type (as in `path/google.protobuf.Duration`). The name should be in a canonical form (e.g., leading \".\" is not accepted).  In practice, teams usually precompile into the binary all types that they expect it to use in the context of Any. However, for URLs which use the scheme `http`, `https`, or no scheme, one can optionally set up a type server that maps type URLs to message definitions as follows:  * If no scheme is provided, `https` is assumed. * An HTTP GET on the URL must yield a [google.protobuf.Type][]   value in binary format, or produce an error. * Applications are allowed to cache lookup results based on the   URL, or have them precompiled into a binary to avoid any   lookup. Therefore, binary compatibility needs to be preserved   on changes to types. (Use versioned type names to manage   breaking changes.)  Note: this functionality is not currently available in the official protobuf release, and it is not used for type URLs beginning with type.googleapis.com. As of May 2023, there are no widely used type server implementations and no plans to implement one.  Schemes other than `http`, `https` (or the empty scheme) might be used with implementation specific semantics.
     * @type {string}
     * @memberof ProtobufAny
     */
    '@type'?: string;
}
/**
 * The `Status` type defines a logical error model that is suitable for different programming environments, including REST APIs and RPC APIs. It is used by [gRPC](https://github.com/grpc). Each `Status` message contains three pieces of data: error code, error message, and error details.  You can find out more about this error model and how to work with it in the [API Design Guide](https://cloud.google.com/apis/design/errors).
 * @export
 * @interface RpcStatus
 */
export interface RpcStatus {
    /**
     * The status code, which should be an enum value of [google.rpc.Code][google.rpc.Code].
     * @type {number}
     * @memberof RpcStatus
     */
    'code'?: number;
    /**
     * A developer-facing error message, which should be in English. Any user-facing error message should be localized and sent in the [google.rpc.Status.details][google.rpc.Status.details] field, or localized by the client.
     * @type {string}
     * @memberof RpcStatus
     */
    'message'?: string;
    /**
     * A list of messages that carry the error details.  There is a common set of message types for APIs to use.
     * @type {Array<ProtobufAny>}
     * @memberof RpcStatus
     */
    'details'?: Array<ProtobufAny>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Telemetryadminv1PaymentGateway = {
    Unspecified: 'PAYMENT_GATEWAY_UNSPECIFIED',
    Xendit: 'PAYMENT_GATEWAY_XENDIT',
    Midtrans: 'PAYMENT_GATEWAY_MIDTRANS'
} as const;

export type Telemetryadminv1PaymentGateway = typeof Telemetryadminv1PaymentGateway[keyof typeof Telemetryadminv1PaymentGateway];


/**
 * 
 * @export
 * @interface TelemetryvendingMachinev1BeltsCoupling
 */
export interface TelemetryvendingMachinev1BeltsCoupling {
    /**
     * 
     * @type {string}
     * @memberof TelemetryvendingMachinev1BeltsCoupling
     */
    'mainMdbItemNumber'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TelemetryvendingMachinev1BeltsCoupling
     */
    'coupledBeltsMdbItemNumbers'?: Array<string>;
}
/**
 * 
 * @export
 * @interface TelemetryvendingMachinev1BlackoutPeriod
 */
export interface TelemetryvendingMachinev1BlackoutPeriod {
    /**
     * 
     * @type {string}
     * @memberof TelemetryvendingMachinev1BlackoutPeriod
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof TelemetryvendingMachinev1BlackoutPeriod
     */
    'finishTime'?: string;
}
/**
 * 
 * @export
 * @interface TelemetryvendingMachinev1Combo
 */
export interface TelemetryvendingMachinev1Combo {
    /**
     * 
     * @type {string}
     * @memberof TelemetryvendingMachinev1Combo
     */
    'comboUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof TelemetryvendingMachinev1Combo
     */
    'internalName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TelemetryvendingMachinev1Combo
     */
    'displayName'?: string;
    /**
     * 
     * @type {number}
     * @memberof TelemetryvendingMachinev1Combo
     */
    'price'?: number;
    /**
     * 
     * @type {string}
     * @memberof TelemetryvendingMachinev1Combo
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof TelemetryvendingMachinev1Combo
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {Array<TelemetryvendingMachinev1ComboProduct>}
     * @memberof TelemetryvendingMachinev1Combo
     */
    'products'?: Array<TelemetryvendingMachinev1ComboProduct>;
    /**
     * 
     * @type {string}
     * @memberof TelemetryvendingMachinev1Combo
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof TelemetryvendingMachinev1Combo
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface TelemetryvendingMachinev1ComboProduct
 */
export interface TelemetryvendingMachinev1ComboProduct {
    /**
     * 
     * @type {string}
     * @memberof TelemetryvendingMachinev1ComboProduct
     */
    'productUuid'?: string;
    /**
     * 
     * @type {number}
     * @memberof TelemetryvendingMachinev1ComboProduct
     */
    'price'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TelemetryvendingMachinev1DefaultBuyPage = {
    Unspecified: 'DEFAULT_BUY_PAGE_UNSPECIFIED',
    Products: 'DEFAULT_BUY_PAGE_PRODUCTS',
    SelectionCode: 'DEFAULT_BUY_PAGE_SELECTION_CODE'
} as const;

export type TelemetryvendingMachinev1DefaultBuyPage = typeof TelemetryvendingMachinev1DefaultBuyPage[keyof typeof TelemetryvendingMachinev1DefaultBuyPage];


/**
 * 
 * @export
 * @enum {string}
 */

export const TelemetryvendingMachinev1EventType = {
    Unspecified: 'EVENT_TYPE_UNSPECIFIED',
    Unlock: 'EVENT_TYPE_UNLOCK',
    RestartProgram: 'EVENT_TYPE_RESTART_PROGRAM',
    Restart: 'EVENT_TYPE_RESTART',
    RestartSlave: 'EVENT_TYPE_RESTART_SLAVE',
    Service: 'EVENT_TYPE_SERVICE',
    ServiceDisconnect: 'EVENT_TYPE_SERVICE_DISCONNECT',
    UploadDiagnosisInfo: 'EVENT_TYPE_UPLOAD_DIAGNOSIS_INFO'
} as const;

export type TelemetryvendingMachinev1EventType = typeof TelemetryvendingMachinev1EventType[keyof typeof TelemetryvendingMachinev1EventType];


/**
 * 
 * @export
 * @interface TelemetryvendingMachinev1ListCombosResponse
 */
export interface TelemetryvendingMachinev1ListCombosResponse {
    /**
     * 
     * @type {Array<TelemetryvendingMachinev1Combo>}
     * @memberof TelemetryvendingMachinev1ListCombosResponse
     */
    'combos'?: Array<TelemetryvendingMachinev1Combo>;
}
/**
 * 
 * @export
 * @interface TelemetryvendingMachinev1ListMotorCouplingsResponse
 */
export interface TelemetryvendingMachinev1ListMotorCouplingsResponse {
    /**
     * 
     * @type {Array<TelemetryvendingMachinev1MotorCoupling>}
     * @memberof TelemetryvendingMachinev1ListMotorCouplingsResponse
     */
    'motorCouplings'?: Array<TelemetryvendingMachinev1MotorCoupling>;
}
/**
 * 
 * @export
 * @interface TelemetryvendingMachinev1ListScreenSaversRequest
 */
export interface TelemetryvendingMachinev1ListScreenSaversRequest {
    /**
     * Frontend can only access vending machine UUID rather than vending machine group ID.
     * @type {string}
     * @memberof TelemetryvendingMachinev1ListScreenSaversRequest
     */
    'vendingMachineGroupUuid'?: string;
}
/**
 * 
 * @export
 * @interface TelemetryvendingMachinev1ListScreenSaversResponse
 */
export interface TelemetryvendingMachinev1ListScreenSaversResponse {
    /**
     * 
     * @type {Array<V1ScreenSavers>}
     * @memberof TelemetryvendingMachinev1ListScreenSaversResponse
     */
    'screenSavers'?: Array<V1ScreenSavers>;
}
/**
 * 
 * @export
 * @interface TelemetryvendingMachinev1MotorCoupling
 */
export interface TelemetryvendingMachinev1MotorCoupling {
    /**
     * 
     * @type {string}
     * @memberof TelemetryvendingMachinev1MotorCoupling
     */
    'mainMdbItemNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof TelemetryvendingMachinev1MotorCoupling
     */
    'coupledMotorMdbItemNumber'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TelemetryvendingMachinev1ScreenSaverMediaType = {
    Unspecified: 'SCREEN_SAVER_MEDIA_TYPE_UNSPECIFIED',
    Image: 'SCREEN_SAVER_MEDIA_TYPE_IMAGE',
    Video: 'SCREEN_SAVER_MEDIA_TYPE_VIDEO'
} as const;

export type TelemetryvendingMachinev1ScreenSaverMediaType = typeof TelemetryvendingMachinev1ScreenSaverMediaType[keyof typeof TelemetryvendingMachinev1ScreenSaverMediaType];


/**
 * 
 * @export
 * @enum {string}
 */

export const TelemetryvendingMachinev1SelectionCodeLength = {
    Unspecified: 'SELECTION_CODE_LENGTH_UNSPECIFIED',
    Four: 'SELECTION_CODE_LENGTH_FOUR',
    Three: 'SELECTION_CODE_LENGTH_THREE',
    Two: 'SELECTION_CODE_LENGTH_TWO'
} as const;

export type TelemetryvendingMachinev1SelectionCodeLength = typeof TelemetryvendingMachinev1SelectionCodeLength[keyof typeof TelemetryvendingMachinev1SelectionCodeLength];


/**
 * 
 * @export
 * @interface TelemetryvendingMachinev1SlaveTemperature
 */
export interface TelemetryvendingMachinev1SlaveTemperature {
    /**
     * 
     * @type {string}
     * @memberof TelemetryvendingMachinev1SlaveTemperature
     */
    'identity'?: string;
    /**
     * 
     * @type {Array<TelemetryvendingMachinev1SlaveTemperatureTemperature>}
     * @memberof TelemetryvendingMachinev1SlaveTemperature
     */
    'temperatures'?: Array<TelemetryvendingMachinev1SlaveTemperatureTemperature>;
    /**
     * 
     * @type {string}
     * @memberof TelemetryvendingMachinev1SlaveTemperature
     */
    'createdAt'?: string;
}
/**
 * 
 * @export
 * @interface TelemetryvendingMachinev1SlaveTemperatureTemperature
 */
export interface TelemetryvendingMachinev1SlaveTemperatureTemperature {
    /**
     * 
     * @type {string}
     * @memberof TelemetryvendingMachinev1SlaveTemperatureTemperature
     */
    'zone'?: string;
    /**
     * 
     * @type {number}
     * @memberof TelemetryvendingMachinev1SlaveTemperatureTemperature
     */
    'value'?: number;
}
/**
 * 
 * @export
 * @interface V1AddScreenSaverRequest
 */
export interface V1AddScreenSaverRequest {
    /**
     * 
     * @type {string}
     * @memberof V1AddScreenSaverRequest
     */
    'screenSaver'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1AddScreenSaverRequest
     */
    'duration'?: string;
    /**
     * Frontend can only access vending machine UUID rather than vending machine group ID.
     * @type {string}
     * @memberof V1AddScreenSaverRequest
     */
    'vendingMachineGroupUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1AddScreenSaverRequest
     */
    'cta'?: string;
    /**
     * 
     * @type {TelemetryvendingMachinev1ScreenSaverMediaType}
     * @memberof V1AddScreenSaverRequest
     */
    'mediaType'?: TelemetryvendingMachinev1ScreenSaverMediaType;
    /**
     * 
     * @type {string}
     * @memberof V1AddScreenSaverRequest
     */
    'screenSaverPath'?: string;
}


/**
 * 
 * @export
 * @interface V1AddScreenSaverResponse
 */
export interface V1AddScreenSaverResponse {
    /**
     * 
     * @type {string}
     * @memberof V1AddScreenSaverResponse
     */
    'screenSaverUuid'?: string;
}
/**
 * 
 * @export
 * @interface V1ClawMachineDispenseRecord
 */
export interface V1ClawMachineDispenseRecord {
    /**
     * 
     * @type {string}
     * @memberof V1ClawMachineDispenseRecord
     */
    'dispensedTime'?: string;
}
/**
 * 
 * @export
 * @interface V1ClawMachineStock
 */
export interface V1ClawMachineStock {
    /**
     * 
     * @type {number}
     * @memberof V1ClawMachineStock
     */
    'currentStock'?: number;
    /**
     * 
     * @type {number}
     * @memberof V1ClawMachineStock
     */
    'restock'?: number;
    /**
     * 
     * @type {number}
     * @memberof V1ClawMachineStock
     */
    'price'?: number;
    /**
     * 
     * @type {string}
     * @memberof V1ClawMachineStock
     */
    'mdbItemNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1ClawMachineStock
     */
    'productId'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1ClawMachineStock
     */
    'productName'?: string;
}
/**
 * 
 * @export
 * @interface V1CreateComboRequest
 */
export interface V1CreateComboRequest {
    /**
     * 
     * @type {string}
     * @memberof V1CreateComboRequest
     */
    'internalName'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1CreateComboRequest
     */
    'displayName'?: string;
    /**
     * 
     * @type {number}
     * @memberof V1CreateComboRequest
     */
    'price'?: number;
    /**
     * 
     * @type {string}
     * @memberof V1CreateComboRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1CreateComboRequest
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {Array<TelemetryvendingMachinev1ComboProduct>}
     * @memberof V1CreateComboRequest
     */
    'products'?: Array<TelemetryvendingMachinev1ComboProduct>;
}
/**
 * 
 * @export
 * @interface V1CreateComboResponse
 */
export interface V1CreateComboResponse {
    /**
     * 
     * @type {string}
     * @memberof V1CreateComboResponse
     */
    'comboUuid'?: string;
}
/**
 * 
 * @export
 * @interface V1CreateGroupComboResponse
 */
export interface V1CreateGroupComboResponse {
    /**
     * 
     * @type {string}
     * @memberof V1CreateGroupComboResponse
     */
    'groupComboUuid'?: string;
}
/**
 * 
 * @export
 * @interface V1DeleteScreenSaverRequest
 */
export interface V1DeleteScreenSaverRequest {
    /**
     * 
     * @type {string}
     * @memberof V1DeleteScreenSaverRequest
     */
    'screenSaverUuid'?: string;
}
/**
 * 
 * @export
 * @interface V1GetClawMachineStocksResponse
 */
export interface V1GetClawMachineStocksResponse {
    /**
     * 
     * @type {Array<V1ClawMachineStock>}
     * @memberof V1GetClawMachineStocksResponse
     */
    'stocks'?: Array<V1ClawMachineStock>;
}
/**
 * 
 * @export
 * @interface V1GetMachineAttributesResponse
 */
export interface V1GetMachineAttributesResponse {
    /**
     * 
     * @type {string}
     * @memberof V1GetMachineAttributesResponse
     */
    'attribute1'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1GetMachineAttributesResponse
     */
    'attribute2'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1GetMachineAttributesResponse
     */
    'attribute3'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1GetMachineAttributesResponse
     */
    'attribute4'?: string;
}
/**
 * 
 * @export
 * @interface V1GetMachineLatestLocationResponse
 */
export interface V1GetMachineLatestLocationResponse {
    /**
     * 
     * @type {V1MachineLocation}
     * @memberof V1GetMachineLatestLocationResponse
     */
    'location'?: V1MachineLocation;
}
/**
 * 
 * @export
 * @interface V1GetMachineTemperaturesResponse
 */
export interface V1GetMachineTemperaturesResponse {
    /**
     * 
     * @type {Array<TelemetryvendingMachinev1SlaveTemperature>}
     * @memberof V1GetMachineTemperaturesResponse
     */
    'slavesTemperatures'?: Array<TelemetryvendingMachinev1SlaveTemperature>;
}
/**
 * 
 * @export
 * @interface V1GetOrganisationSettingsResponse
 */
export interface V1GetOrganisationSettingsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof V1GetOrganisationSettingsResponse
     */
    'productEditableFromVendingMachine'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof V1GetOrganisationSettingsResponse
     */
    'xenditSecretKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1GetOrganisationSettingsResponse
     */
    'maskedMidtransServerKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1GetOrganisationSettingsResponse
     */
    'maskedMidtransClientKey'?: string;
    /**
     * 
     * @type {Telemetryadminv1PaymentGateway}
     * @memberof V1GetOrganisationSettingsResponse
     */
    'qrcodePaymentGateway'?: Telemetryadminv1PaymentGateway;
    /**
     * Skip automatic refund. If enabled, the server will not do automatic refund even if the payment gateway supports it and during vend failure.
     * @type {boolean}
     * @memberof V1GetOrganisationSettingsResponse
     */
    'skipAutomaticRefund'?: boolean;
}


/**
 * 
 * @export
 * @interface V1GetProductAttributesResponse
 */
export interface V1GetProductAttributesResponse {
    /**
     * 
     * @type {string}
     * @memberof V1GetProductAttributesResponse
     */
    'attribute1'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1GetProductAttributesResponse
     */
    'attribute2'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1GetProductAttributesResponse
     */
    'attribute3'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1GetProductAttributesResponse
     */
    'attribute4'?: string;
}
/**
 * 
 * @export
 * @interface V1GetS3UploadPathResponse
 */
export interface V1GetS3UploadPathResponse {
    /**
     * 
     * @type {string}
     * @memberof V1GetS3UploadPathResponse
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1GetS3UploadPathResponse
     */
    'path'?: string;
}
/**
 * 
 * @export
 * @interface V1GetVendingMachineGroupInfoResponse
 */
export interface V1GetVendingMachineGroupInfoResponse {
    /**
     * 
     * @type {string}
     * @memberof V1GetVendingMachineGroupInfoResponse
     */
    'groupUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1GetVendingMachineGroupInfoResponse
     */
    'organizationName'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1GetVendingMachineGroupInfoResponse
     */
    'organizationContact'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1GetVendingMachineGroupInfoResponse
     */
    'organizationEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1GetVendingMachineGroupInfoResponse
     */
    'organizationIntro'?: string;
}
/**
 * 
 * @export
 * @interface V1GetVmcpOrderDetailResponse
 */
export interface V1GetVmcpOrderDetailResponse {
    /**
     * 
     * @type {V1VmcpOrder}
     * @memberof V1GetVmcpOrderDetailResponse
     */
    'order'?: V1VmcpOrder;
}
/**
 * 
 * @export
 * @interface V1GroupCombo
 */
export interface V1GroupCombo {
    /**
     * 
     * @type {string}
     * @memberof V1GroupCombo
     */
    'groupComboUuid'?: string;
    /**
     * 
     * @type {TelemetryvendingMachinev1Combo}
     * @memberof V1GroupCombo
     */
    'combo'?: TelemetryvendingMachinev1Combo;
    /**
     * 
     * @type {number}
     * @memberof V1GroupCombo
     */
    'displayPriority'?: number;
    /**
     * 
     * @type {string}
     * @memberof V1GroupCombo
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1GroupCombo
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface V1ListBeltsCouplingsResponse
 */
export interface V1ListBeltsCouplingsResponse {
    /**
     * 
     * @type {Array<TelemetryvendingMachinev1BeltsCoupling>}
     * @memberof V1ListBeltsCouplingsResponse
     */
    'beltsCouplings'?: Array<TelemetryvendingMachinev1BeltsCoupling>;
}
/**
 * 
 * @export
 * @interface V1ListClawMachineDispenseRecordsResponse
 */
export interface V1ListClawMachineDispenseRecordsResponse {
    /**
     * 
     * @type {Array<V1ClawMachineDispenseRecord>}
     * @memberof V1ListClawMachineDispenseRecordsResponse
     */
    'dispenseRecords'?: Array<V1ClawMachineDispenseRecord>;
    /**
     * 
     * @type {number}
     * @memberof V1ListClawMachineDispenseRecordsResponse
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface V1ListGroupCombosResponse
 */
export interface V1ListGroupCombosResponse {
    /**
     * 
     * @type {Array<V1GroupCombo>}
     * @memberof V1ListGroupCombosResponse
     */
    'groupCombos'?: Array<V1GroupCombo>;
}
/**
 * 
 * @export
 * @interface V1ListMachinesOnlineStatusRequest
 */
export interface V1ListMachinesOnlineStatusRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof V1ListMachinesOnlineStatusRequest
     */
    'vmids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface V1ListMachinesOnlineStatusResponse
 */
export interface V1ListMachinesOnlineStatusResponse {
    /**
     * 
     * @type {Array<V1MachineOnlineStatus>}
     * @memberof V1ListMachinesOnlineStatusResponse
     */
    'machinesOnlineStatus'?: Array<V1MachineOnlineStatus>;
}
/**
 * 
 * @export
 * @interface V1ListPaymentEventsResponse
 */
export interface V1ListPaymentEventsResponse {
    /**
     * 
     * @type {Array<V1PaymentEvent>}
     * @memberof V1ListPaymentEventsResponse
     */
    'paymentEvents'?: Array<V1PaymentEvent>;
    /**
     * 
     * @type {number}
     * @memberof V1ListPaymentEventsResponse
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface V1MachineDetailResponse
 */
export interface V1MachineDetailResponse {
    /**
     * 
     * @type {string}
     * @memberof V1MachineDetailResponse
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1MachineDetailResponse
     */
    'timezone'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1MachineDetailResponse
     */
    'currencyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1MachineDetailResponse
     */
    'currencySymbol'?: string;
    /**
     * 
     * @type {number}
     * @memberof V1MachineDetailResponse
     */
    'currencyDecimalPoint'?: number;
    /**
     * 
     * @type {string}
     * @memberof V1MachineDetailResponse
     */
    'pinCode'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof V1MachineDetailResponse
     */
    'disabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof V1MachineDetailResponse
     */
    'globalLowStockAlertPercentage'?: number;
    /**
     * 
     * @type {TelemetryvendingMachinev1DefaultBuyPage}
     * @memberof V1MachineDetailResponse
     */
    'defaultBuyPage'?: TelemetryvendingMachinev1DefaultBuyPage;
    /**
     * 
     * @type {boolean}
     * @memberof V1MachineDetailResponse
     */
    'blackoutPeriodEnabled'?: boolean;
    /**
     * 
     * @type {Array<TelemetryvendingMachinev1BlackoutPeriod>}
     * @memberof V1MachineDetailResponse
     */
    'blackoutPeriods'?: Array<TelemetryvendingMachinev1BlackoutPeriod>;
    /**
     * When One-Based Numbering is enabled, the first tray is referred as 1. The selection starts from 1100, and then 1101. Next tray is 1200, 1201 etc.
     * @type {boolean}
     * @memberof V1MachineDetailResponse
     */
    'oneBasedNumberingEnabled'?: boolean;
    /**
     * 
     * @type {TelemetryvendingMachinev1SelectionCodeLength}
     * @memberof V1MachineDetailResponse
     */
    'selectionCodeLength'?: TelemetryvendingMachinev1SelectionCodeLength;
    /**
     * 
     * @type {boolean}
     * @memberof V1MachineDetailResponse
     */
    'shoppingCartDisabled'?: boolean;
    /**
     * If buy page locked, consumer can\'t switch between different screens, e.g. product display or keyboard based. This option is related to default_buy_page.
     * @type {boolean}
     * @memberof V1MachineDetailResponse
     */
    'buyPageLocked'?: boolean;
    /**
     * Skip automatic refund. If enabled, the server will not do automatic refund even if the payment gateway supports it and during vend failure.
     * @type {boolean}
     * @memberof V1MachineDetailResponse
     */
    'skipAutomaticRefund'?: boolean;
    /**
     * The signal strength of the 4g LTE connection, 0 means no signal, 100 means full signal strength.
     * @type {number}
     * @memberof V1MachineDetailResponse
     */
    'signalStrength'?: number;
    /**
     * The last time the signal strength of the 4g LTE connection was updated.
     * @type {string}
     * @memberof V1MachineDetailResponse
     */
    'lastSignalStrengthUpdatedAt'?: string;
    /**
     * payment_disabled indicates whether the payment gateway is disabled for this vending machine.
     * @type {boolean}
     * @memberof V1MachineDetailResponse
     */
    'paymentDisabled'?: boolean;
    /**
     * skip_failure_blocking when enabled, the slot that failed to dispense the item will not be blocked.
     * @type {boolean}
     * @memberof V1MachineDetailResponse
     */
    'skipFailureBlocking'?: boolean;
}


/**
 * 
 * @export
 * @interface V1MachineLocation
 */
export interface V1MachineLocation {
    /**
     * 
     * @type {number}
     * @memberof V1MachineLocation
     */
    'latitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof V1MachineLocation
     */
    'longitude'?: number;
    /**
     * 
     * @type {string}
     * @memberof V1MachineLocation
     */
    'createdAt'?: string;
}
/**
 * 
 * @export
 * @interface V1MachineOnlineStatus
 */
export interface V1MachineOnlineStatus {
    /**
     * 
     * @type {string}
     * @memberof V1MachineOnlineStatus
     */
    'vmid'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof V1MachineOnlineStatus
     */
    'online'?: boolean;
}
/**
 * 
 * @export
 * @interface V1PaymentEvent
 */
export interface V1PaymentEvent {
    /**
     * 
     * @type {string}
     * @memberof V1PaymentEvent
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1PaymentEvent
     */
    'orderUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1PaymentEvent
     */
    'event'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1PaymentEvent
     */
    'receiptId'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1PaymentEvent
     */
    'bodyData'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1PaymentEvent
     */
    'createdAt'?: string;
    /**
     * 
     * @type {Telemetryadminv1PaymentGateway}
     * @memberof V1PaymentEvent
     */
    'paymentGateway'?: Telemetryadminv1PaymentGateway;
}


/**
 * 
 * @export
 * @interface V1ResetVendDelayPeriodRequest
 */
export interface V1ResetVendDelayPeriodRequest {
    /**
     * 
     * @type {string}
     * @memberof V1ResetVendDelayPeriodRequest
     */
    'vmid'?: string;
}
/**
 * 
 * @export
 * @interface V1RestartMachineRequest
 */
export interface V1RestartMachineRequest {
    /**
     * 
     * @type {string}
     * @memberof V1RestartMachineRequest
     */
    'vmid'?: string;
}
/**
 * 
 * @export
 * @interface V1ScreenSavers
 */
export interface V1ScreenSavers {
    /**
     * 
     * @type {string}
     * @memberof V1ScreenSavers
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1ScreenSavers
     */
    'screenUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1ScreenSavers
     */
    'duration'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1ScreenSavers
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1ScreenSavers
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1ScreenSavers
     */
    'cta'?: string;
    /**
     * 
     * @type {TelemetryvendingMachinev1ScreenSaverMediaType}
     * @memberof V1ScreenSavers
     */
    'mediaType'?: TelemetryvendingMachinev1ScreenSaverMediaType;
    /**
     * 
     * @type {string}
     * @memberof V1ScreenSavers
     */
    'mediaLowQualityUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1ScreenSavers
     */
    'mediaConvertJobStatus'?: string;
}


/**
 * 
 * @export
 * @interface V1SearchOrderByReceiptIdResponse
 */
export interface V1SearchOrderByReceiptIdResponse {
    /**
     * 
     * @type {V1VmcpOrder}
     * @memberof V1SearchOrderByReceiptIdResponse
     */
    'order'?: V1VmcpOrder;
    /**
     * 
     * @type {Array<V1VmcpOrderItem>}
     * @memberof V1SearchOrderByReceiptIdResponse
     */
    'orderItems'?: Array<V1VmcpOrderItem>;
    /**
     * 
     * @type {Array<V1PaymentEvent>}
     * @memberof V1SearchOrderByReceiptIdResponse
     */
    'paymentEvents'?: Array<V1PaymentEvent>;
}
/**
 * 
 * @export
 * @interface V1SearchPaymentEventsResponse
 */
export interface V1SearchPaymentEventsResponse {
    /**
     * 
     * @type {Array<V1PaymentEvent>}
     * @memberof V1SearchPaymentEventsResponse
     */
    'paymentEvents'?: Array<V1PaymentEvent>;
    /**
     * 
     * @type {number}
     * @memberof V1SearchPaymentEventsResponse
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface V1UpdateOrganisationSettingsRequest
 */
export interface V1UpdateOrganisationSettingsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof V1UpdateOrganisationSettingsRequest
     */
    'productEditableFromVendingMachine'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof V1UpdateOrganisationSettingsRequest
     */
    'xenditSecretKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1UpdateOrganisationSettingsRequest
     */
    'midtransServerKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1UpdateOrganisationSettingsRequest
     */
    'midtransClientKey'?: string;
    /**
     * 
     * @type {Telemetryadminv1PaymentGateway}
     * @memberof V1UpdateOrganisationSettingsRequest
     */
    'qrcodePaymentGateway'?: Telemetryadminv1PaymentGateway;
    /**
     * Skip automatic refund. If enabled, the server will not do automatic refund even if the payment gateway supports it and during vend failure.
     * @type {boolean}
     * @memberof V1UpdateOrganisationSettingsRequest
     */
    'skipAutomaticRefund'?: boolean;
}


/**
 * 
 * @export
 * @interface V1UpdateVendDelayRequest
 */
export interface V1UpdateVendDelayRequest {
    /**
     * 
     * @type {string}
     * @memberof V1UpdateVendDelayRequest
     */
    'vmid'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1UpdateVendDelayRequest
     */
    'delay'?: string;
}
/**
 * 
 * @export
 * @interface V1VmcpOrder
 */
export interface V1VmcpOrder {
    /**
     * 
     * @type {string}
     * @memberof V1VmcpOrder
     */
    'orderUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1VmcpOrder
     */
    'qrcodeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1VmcpOrder
     */
    'qrpayId'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1VmcpOrder
     */
    'paidAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1VmcpOrder
     */
    'refundedAt'?: string;
    /**
     * 
     * @type {Telemetryadminv1PaymentGateway}
     * @memberof V1VmcpOrder
     */
    'paymentGateway'?: Telemetryadminv1PaymentGateway;
    /**
     * 
     * @type {Paymentsqrcodev1OrderState}
     * @memberof V1VmcpOrder
     */
    'state'?: Paymentsqrcodev1OrderState;
    /**
     * 
     * @type {string}
     * @memberof V1VmcpOrder
     */
    'receiptId'?: string;
}


/**
 * 
 * @export
 * @interface V1VmcpOrderItem
 */
export interface V1VmcpOrderItem {
    /**
     * 
     * @type {string}
     * @memberof V1VmcpOrderItem
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1VmcpOrderItem
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1VmcpOrderItem
     */
    'mdbItemNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1VmcpOrderItem
     */
    'currency'?: string;
    /**
     * 
     * @type {number}
     * @memberof V1VmcpOrderItem
     */
    'price'?: number;
    /**
     * 
     * @type {string}
     * @memberof V1VmcpOrderItem
     */
    'url'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof V1VmcpOrderItem
     */
    'isRefunded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof V1VmcpOrderItem
     */
    'status'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof V1VmcpOrderItem
     */
    'isCombo'?: boolean;
}
/**
 * 
 * @export
 * @interface VendingMachineGroupServiceCreateGroupComboRequest
 */
export interface VendingMachineGroupServiceCreateGroupComboRequest {
    /**
     * 
     * @type {string}
     * @memberof VendingMachineGroupServiceCreateGroupComboRequest
     */
    'comboUuid'?: string;
    /**
     * 
     * @type {number}
     * @memberof VendingMachineGroupServiceCreateGroupComboRequest
     */
    'displayPriority'?: number;
}
/**
 * 
 * @export
 * @interface VendingMachineGroupServiceUpdateGroupComboRequest
 */
export interface VendingMachineGroupServiceUpdateGroupComboRequest {
    /**
     * 
     * @type {number}
     * @memberof VendingMachineGroupServiceUpdateGroupComboRequest
     */
    'displayPriority'?: number;
}
/**
 * 
 * @export
 * @interface VendingMachineGroupServiceUpdateVendingMachineGroupRequest
 */
export interface VendingMachineGroupServiceUpdateVendingMachineGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof VendingMachineGroupServiceUpdateVendingMachineGroupRequest
     */
    'organizationName'?: string;
    /**
     * 
     * @type {string}
     * @memberof VendingMachineGroupServiceUpdateVendingMachineGroupRequest
     */
    'organizationContact'?: string;
    /**
     * 
     * @type {string}
     * @memberof VendingMachineGroupServiceUpdateVendingMachineGroupRequest
     */
    'organizationEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof VendingMachineGroupServiceUpdateVendingMachineGroupRequest
     */
    'organizationIntro'?: string;
}

/**
 * MachineManagementServiceApi - axios parameter creator
 * @export
 */
export const MachineManagementServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get claw machine stocks
         * @param {string} vmid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceGetClawMachineStocks: async (vmid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmid' is not null or undefined
            assertParamExists('machineManagementServiceGetClawMachineStocks', 'vmid', vmid)
            const localVarPath = `/api-ng/telemetry/vending_machine/v1/{vmid}/claw_machine_stocks`
                .replace(`{${"vmid"}}`, encodeURIComponent(String(vmid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get machine attributes
         * @param {string} vmid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceGetMachineAttributes: async (vmid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmid' is not null or undefined
            assertParamExists('machineManagementServiceGetMachineAttributes', 'vmid', vmid)
            const localVarPath = `/api-ng/telemetry/vending_machine/v1/{vmid}/attributes`
                .replace(`{${"vmid"}}`, encodeURIComponent(String(vmid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get machine latest location
         * @param {string} vmid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceGetMachineLatestLocation: async (vmid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmid' is not null or undefined
            assertParamExists('machineManagementServiceGetMachineLatestLocation', 'vmid', vmid)
            const localVarPath = `/api-ng/telemetry/vending_machine/v1/{vmid}/latest_location`
                .replace(`{${"vmid"}}`, encodeURIComponent(String(vmid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get vending machine temperatures
         * @param {string} vmid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceGetMachineTemperatures: async (vmid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmid' is not null or undefined
            assertParamExists('machineManagementServiceGetMachineTemperatures', 'vmid', vmid)
            const localVarPath = `/api-ng/telemetry/vending_machine/v1/{vmid}/temperatures`
                .replace(`{${"vmid"}}`, encodeURIComponent(String(vmid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List belts couplings
         * @param {string} vmid vmid, aka vending machine uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceListBeltsCouplings: async (vmid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmid' is not null or undefined
            assertParamExists('machineManagementServiceListBeltsCouplings', 'vmid', vmid)
            const localVarPath = `/api-ng/telemetry/vending_machine/v1/{vmid}/belts_couplings`
                .replace(`{${"vmid"}}`, encodeURIComponent(String(vmid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List claw machine dispense records
         * @param {string} vmid 
         * @param {number} [page] current page num
         * @param {number} [perPage] display the number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceListClawMachineDispenseRecords: async (vmid: string, page?: number, perPage?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmid' is not null or undefined
            assertParamExists('machineManagementServiceListClawMachineDispenseRecords', 'vmid', vmid)
            const localVarPath = `/api-ng/telemetry/vending_machine/v1/{vmid}/claw_machine_dispense_records`
                .replace(`{${"vmid"}}`, encodeURIComponent(String(vmid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['perPage'] = perPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list machines online status
         * @param {V1ListMachinesOnlineStatusRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceListMachinesOnlineStatus: async (body: V1ListMachinesOnlineStatusRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('machineManagementServiceListMachinesOnlineStatus', 'body', body)
            const localVarPath = `/api-ng/telemetry/vending_machine/v1/machines-online-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List motor couplings
         * @param {string} vmid vmid, aka vending machine uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceListMotorCouplings: async (vmid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmid' is not null or undefined
            assertParamExists('machineManagementServiceListMotorCouplings', 'vmid', vmid)
            const localVarPath = `/api-ng/telemetry/vending_machine/v1/{vmid}/motor_couplings`
                .replace(`{${"vmid"}}`, encodeURIComponent(String(vmid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get vending machine detail
         * @param {string} vmid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceMachineDetail: async (vmid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmid' is not null or undefined
            assertParamExists('machineManagementServiceMachineDetail', 'vmid', vmid)
            const localVarPath = `/api-ng/telemetry/vending_machine/v1/{vmid}/detail`
                .replace(`{${"vmid"}}`, encodeURIComponent(String(vmid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  Reset current vend delay period
         * @param {V1ResetVendDelayPeriodRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceResetVendDelayPeriod: async (body: V1ResetVendDelayPeriodRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('machineManagementServiceResetVendDelayPeriod', 'body', body)
            const localVarPath = `/api-ng/telemetry/vending_machine/v1/reset_vend_delay`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  RestartMachine to system 
         * @param {V1RestartMachineRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceRestartMachine: async (body: V1RestartMachineRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('machineManagementServiceRestartMachine', 'body', body)
            const localVarPath = `/api-ng/telemetry/vending_machine/v1/restart_machine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary send event to vending machine
         * @param {string} vmid 
         * @param {MachineManagementServiceSendEventToMachineRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceSendEventToMachine: async (vmid: string, body: MachineManagementServiceSendEventToMachineRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmid' is not null or undefined
            assertParamExists('machineManagementServiceSendEventToMachine', 'vmid', vmid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('machineManagementServiceSendEventToMachine', 'body', body)
            const localVarPath = `/api-ng/telemetry/vending_machine/v1/send_event/{vmid}`
                .replace(`{${"vmid"}}`, encodeURIComponent(String(vmid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update belts couplings
         * @param {string} vmid vmid, aka vending machine uuid
         * @param {MachineManagementServiceUpdateBeltsCouplingsRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceUpdateBeltsCouplings: async (vmid: string, body: MachineManagementServiceUpdateBeltsCouplingsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmid' is not null or undefined
            assertParamExists('machineManagementServiceUpdateBeltsCouplings', 'vmid', vmid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('machineManagementServiceUpdateBeltsCouplings', 'body', body)
            const localVarPath = `/api-ng/telemetry/vending_machine/v1/{vmid}/belts_couplings`
                .replace(`{${"vmid"}}`, encodeURIComponent(String(vmid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update vending machine
         * @param {string} vmid 
         * @param {MachineManagementServiceUpdateMachineRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceUpdateMachine: async (vmid: string, body: MachineManagementServiceUpdateMachineRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmid' is not null or undefined
            assertParamExists('machineManagementServiceUpdateMachine', 'vmid', vmid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('machineManagementServiceUpdateMachine', 'body', body)
            const localVarPath = `/api-ng/telemetry/vending_machine/v1/{vmid}/update`
                .replace(`{${"vmid"}}`, encodeURIComponent(String(vmid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update machine attributes
         * @param {string} vmid 
         * @param {ProductServiceUpdateProductAttributesRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceUpdateMachineAttributes: async (vmid: string, body: ProductServiceUpdateProductAttributesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmid' is not null or undefined
            assertParamExists('machineManagementServiceUpdateMachineAttributes', 'vmid', vmid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('machineManagementServiceUpdateMachineAttributes', 'body', body)
            const localVarPath = `/api-ng/telemetry/vending_machine/v1/{vmid}/attributes`
                .replace(`{${"vmid"}}`, encodeURIComponent(String(vmid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update vending machine blackout period
         * @param {string} vmid 
         * @param {MachineManagementServiceUpdateMachineBlackoutPeriodRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceUpdateMachineBlackoutPeriod: async (vmid: string, body: MachineManagementServiceUpdateMachineBlackoutPeriodRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmid' is not null or undefined
            assertParamExists('machineManagementServiceUpdateMachineBlackoutPeriod', 'vmid', vmid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('machineManagementServiceUpdateMachineBlackoutPeriod', 'body', body)
            const localVarPath = `/api-ng/telemetry/vending_machine/v1/{vmid}/blackout_period/update`
                .replace(`{${"vmid"}}`, encodeURIComponent(String(vmid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update motor couplings
         * @param {string} vmid vmid, aka vending machine uuid
         * @param {MachineManagementServiceUpdateMotorCouplingsRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceUpdateMotorCouplings: async (vmid: string, body: MachineManagementServiceUpdateMotorCouplingsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmid' is not null or undefined
            assertParamExists('machineManagementServiceUpdateMotorCouplings', 'vmid', vmid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('machineManagementServiceUpdateMotorCouplings', 'body', body)
            const localVarPath = `/api-ng/telemetry/vending_machine/v1/{vmid}/motor_couplings`
                .replace(`{${"vmid"}}`, encodeURIComponent(String(vmid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  Update vend delay settings for the vending machine 
         * @param {V1UpdateVendDelayRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceUpdateVendDelay: async (body: V1UpdateVendDelayRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('machineManagementServiceUpdateVendDelay', 'body', body)
            const localVarPath = `/api-ng/telemetry/vending_machine/v1/delay_machine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MachineManagementServiceApi - functional programming interface
 * @export
 */
export const MachineManagementServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MachineManagementServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get claw machine stocks
         * @param {string} vmid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async machineManagementServiceGetClawMachineStocks(vmid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetClawMachineStocksResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.machineManagementServiceGetClawMachineStocks(vmid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get machine attributes
         * @param {string} vmid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async machineManagementServiceGetMachineAttributes(vmid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetMachineAttributesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.machineManagementServiceGetMachineAttributes(vmid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get machine latest location
         * @param {string} vmid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async machineManagementServiceGetMachineLatestLocation(vmid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetMachineLatestLocationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.machineManagementServiceGetMachineLatestLocation(vmid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get vending machine temperatures
         * @param {string} vmid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async machineManagementServiceGetMachineTemperatures(vmid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetMachineTemperaturesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.machineManagementServiceGetMachineTemperatures(vmid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List belts couplings
         * @param {string} vmid vmid, aka vending machine uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async machineManagementServiceListBeltsCouplings(vmid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListBeltsCouplingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.machineManagementServiceListBeltsCouplings(vmid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List claw machine dispense records
         * @param {string} vmid 
         * @param {number} [page] current page num
         * @param {number} [perPage] display the number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async machineManagementServiceListClawMachineDispenseRecords(vmid: string, page?: number, perPage?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListClawMachineDispenseRecordsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.machineManagementServiceListClawMachineDispenseRecords(vmid, page, perPage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary list machines online status
         * @param {V1ListMachinesOnlineStatusRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async machineManagementServiceListMachinesOnlineStatus(body: V1ListMachinesOnlineStatusRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListMachinesOnlineStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.machineManagementServiceListMachinesOnlineStatus(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List motor couplings
         * @param {string} vmid vmid, aka vending machine uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async machineManagementServiceListMotorCouplings(vmid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TelemetryvendingMachinev1ListMotorCouplingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.machineManagementServiceListMotorCouplings(vmid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get vending machine detail
         * @param {string} vmid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async machineManagementServiceMachineDetail(vmid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1MachineDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.machineManagementServiceMachineDetail(vmid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary  Reset current vend delay period
         * @param {V1ResetVendDelayPeriodRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async machineManagementServiceResetVendDelayPeriod(body: V1ResetVendDelayPeriodRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.machineManagementServiceResetVendDelayPeriod(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary  RestartMachine to system 
         * @param {V1RestartMachineRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async machineManagementServiceRestartMachine(body: V1RestartMachineRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.machineManagementServiceRestartMachine(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary send event to vending machine
         * @param {string} vmid 
         * @param {MachineManagementServiceSendEventToMachineRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async machineManagementServiceSendEventToMachine(vmid: string, body: MachineManagementServiceSendEventToMachineRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.machineManagementServiceSendEventToMachine(vmid, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update belts couplings
         * @param {string} vmid vmid, aka vending machine uuid
         * @param {MachineManagementServiceUpdateBeltsCouplingsRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async machineManagementServiceUpdateBeltsCouplings(vmid: string, body: MachineManagementServiceUpdateBeltsCouplingsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.machineManagementServiceUpdateBeltsCouplings(vmid, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update vending machine
         * @param {string} vmid 
         * @param {MachineManagementServiceUpdateMachineRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async machineManagementServiceUpdateMachine(vmid: string, body: MachineManagementServiceUpdateMachineRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.machineManagementServiceUpdateMachine(vmid, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update machine attributes
         * @param {string} vmid 
         * @param {ProductServiceUpdateProductAttributesRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async machineManagementServiceUpdateMachineAttributes(vmid: string, body: ProductServiceUpdateProductAttributesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.machineManagementServiceUpdateMachineAttributes(vmid, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update vending machine blackout period
         * @param {string} vmid 
         * @param {MachineManagementServiceUpdateMachineBlackoutPeriodRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async machineManagementServiceUpdateMachineBlackoutPeriod(vmid: string, body: MachineManagementServiceUpdateMachineBlackoutPeriodRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.machineManagementServiceUpdateMachineBlackoutPeriod(vmid, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update motor couplings
         * @param {string} vmid vmid, aka vending machine uuid
         * @param {MachineManagementServiceUpdateMotorCouplingsRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async machineManagementServiceUpdateMotorCouplings(vmid: string, body: MachineManagementServiceUpdateMotorCouplingsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.machineManagementServiceUpdateMotorCouplings(vmid, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary  Update vend delay settings for the vending machine 
         * @param {V1UpdateVendDelayRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async machineManagementServiceUpdateVendDelay(body: V1UpdateVendDelayRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.machineManagementServiceUpdateVendDelay(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MachineManagementServiceApi - factory interface
 * @export
 */
export const MachineManagementServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MachineManagementServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary Get claw machine stocks
         * @param {string} vmid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceGetClawMachineStocks(vmid: string, options?: any): AxiosPromise<V1GetClawMachineStocksResponse> {
            return localVarFp.machineManagementServiceGetClawMachineStocks(vmid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get machine attributes
         * @param {string} vmid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceGetMachineAttributes(vmid: string, options?: any): AxiosPromise<V1GetMachineAttributesResponse> {
            return localVarFp.machineManagementServiceGetMachineAttributes(vmid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get machine latest location
         * @param {string} vmid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceGetMachineLatestLocation(vmid: string, options?: any): AxiosPromise<V1GetMachineLatestLocationResponse> {
            return localVarFp.machineManagementServiceGetMachineLatestLocation(vmid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get vending machine temperatures
         * @param {string} vmid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceGetMachineTemperatures(vmid: string, options?: any): AxiosPromise<V1GetMachineTemperaturesResponse> {
            return localVarFp.machineManagementServiceGetMachineTemperatures(vmid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List belts couplings
         * @param {string} vmid vmid, aka vending machine uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceListBeltsCouplings(vmid: string, options?: any): AxiosPromise<V1ListBeltsCouplingsResponse> {
            return localVarFp.machineManagementServiceListBeltsCouplings(vmid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List claw machine dispense records
         * @param {string} vmid 
         * @param {number} [page] current page num
         * @param {number} [perPage] display the number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceListClawMachineDispenseRecords(vmid: string, page?: number, perPage?: number, options?: any): AxiosPromise<V1ListClawMachineDispenseRecordsResponse> {
            return localVarFp.machineManagementServiceListClawMachineDispenseRecords(vmid, page, perPage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list machines online status
         * @param {V1ListMachinesOnlineStatusRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceListMachinesOnlineStatus(body: V1ListMachinesOnlineStatusRequest, options?: any): AxiosPromise<V1ListMachinesOnlineStatusResponse> {
            return localVarFp.machineManagementServiceListMachinesOnlineStatus(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List motor couplings
         * @param {string} vmid vmid, aka vending machine uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceListMotorCouplings(vmid: string, options?: any): AxiosPromise<TelemetryvendingMachinev1ListMotorCouplingsResponse> {
            return localVarFp.machineManagementServiceListMotorCouplings(vmid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get vending machine detail
         * @param {string} vmid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceMachineDetail(vmid: string, options?: any): AxiosPromise<V1MachineDetailResponse> {
            return localVarFp.machineManagementServiceMachineDetail(vmid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  Reset current vend delay period
         * @param {V1ResetVendDelayPeriodRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceResetVendDelayPeriod(body: V1ResetVendDelayPeriodRequest, options?: any): AxiosPromise<object> {
            return localVarFp.machineManagementServiceResetVendDelayPeriod(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  RestartMachine to system 
         * @param {V1RestartMachineRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceRestartMachine(body: V1RestartMachineRequest, options?: any): AxiosPromise<object> {
            return localVarFp.machineManagementServiceRestartMachine(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary send event to vending machine
         * @param {string} vmid 
         * @param {MachineManagementServiceSendEventToMachineRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceSendEventToMachine(vmid: string, body: MachineManagementServiceSendEventToMachineRequest, options?: any): AxiosPromise<object> {
            return localVarFp.machineManagementServiceSendEventToMachine(vmid, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update belts couplings
         * @param {string} vmid vmid, aka vending machine uuid
         * @param {MachineManagementServiceUpdateBeltsCouplingsRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceUpdateBeltsCouplings(vmid: string, body: MachineManagementServiceUpdateBeltsCouplingsRequest, options?: any): AxiosPromise<object> {
            return localVarFp.machineManagementServiceUpdateBeltsCouplings(vmid, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update vending machine
         * @param {string} vmid 
         * @param {MachineManagementServiceUpdateMachineRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceUpdateMachine(vmid: string, body: MachineManagementServiceUpdateMachineRequest, options?: any): AxiosPromise<object> {
            return localVarFp.machineManagementServiceUpdateMachine(vmid, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update machine attributes
         * @param {string} vmid 
         * @param {ProductServiceUpdateProductAttributesRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceUpdateMachineAttributes(vmid: string, body: ProductServiceUpdateProductAttributesRequest, options?: any): AxiosPromise<object> {
            return localVarFp.machineManagementServiceUpdateMachineAttributes(vmid, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update vending machine blackout period
         * @param {string} vmid 
         * @param {MachineManagementServiceUpdateMachineBlackoutPeriodRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceUpdateMachineBlackoutPeriod(vmid: string, body: MachineManagementServiceUpdateMachineBlackoutPeriodRequest, options?: any): AxiosPromise<object> {
            return localVarFp.machineManagementServiceUpdateMachineBlackoutPeriod(vmid, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update motor couplings
         * @param {string} vmid vmid, aka vending machine uuid
         * @param {MachineManagementServiceUpdateMotorCouplingsRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceUpdateMotorCouplings(vmid: string, body: MachineManagementServiceUpdateMotorCouplingsRequest, options?: any): AxiosPromise<object> {
            return localVarFp.machineManagementServiceUpdateMotorCouplings(vmid, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  Update vend delay settings for the vending machine 
         * @param {V1UpdateVendDelayRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineManagementServiceUpdateVendDelay(body: V1UpdateVendDelayRequest, options?: any): AxiosPromise<object> {
            return localVarFp.machineManagementServiceUpdateVendDelay(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MachineManagementServiceApi - object-oriented interface
 * @export
 * @class MachineManagementServiceApi
 * @extends {BaseAPI}
 */
export class MachineManagementServiceApi extends BaseAPI {
    /**
     * 
     * @summary Get claw machine stocks
     * @param {string} vmid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineManagementServiceApi
     */
    public machineManagementServiceGetClawMachineStocks(vmid: string, options?: AxiosRequestConfig) {
        return MachineManagementServiceApiFp(this.configuration).machineManagementServiceGetClawMachineStocks(vmid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get machine attributes
     * @param {string} vmid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineManagementServiceApi
     */
    public machineManagementServiceGetMachineAttributes(vmid: string, options?: AxiosRequestConfig) {
        return MachineManagementServiceApiFp(this.configuration).machineManagementServiceGetMachineAttributes(vmid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get machine latest location
     * @param {string} vmid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineManagementServiceApi
     */
    public machineManagementServiceGetMachineLatestLocation(vmid: string, options?: AxiosRequestConfig) {
        return MachineManagementServiceApiFp(this.configuration).machineManagementServiceGetMachineLatestLocation(vmid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get vending machine temperatures
     * @param {string} vmid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineManagementServiceApi
     */
    public machineManagementServiceGetMachineTemperatures(vmid: string, options?: AxiosRequestConfig) {
        return MachineManagementServiceApiFp(this.configuration).machineManagementServiceGetMachineTemperatures(vmid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List belts couplings
     * @param {string} vmid vmid, aka vending machine uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineManagementServiceApi
     */
    public machineManagementServiceListBeltsCouplings(vmid: string, options?: AxiosRequestConfig) {
        return MachineManagementServiceApiFp(this.configuration).machineManagementServiceListBeltsCouplings(vmid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List claw machine dispense records
     * @param {string} vmid 
     * @param {number} [page] current page num
     * @param {number} [perPage] display the number of items per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineManagementServiceApi
     */
    public machineManagementServiceListClawMachineDispenseRecords(vmid: string, page?: number, perPage?: number, options?: AxiosRequestConfig) {
        return MachineManagementServiceApiFp(this.configuration).machineManagementServiceListClawMachineDispenseRecords(vmid, page, perPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list machines online status
     * @param {V1ListMachinesOnlineStatusRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineManagementServiceApi
     */
    public machineManagementServiceListMachinesOnlineStatus(body: V1ListMachinesOnlineStatusRequest, options?: AxiosRequestConfig) {
        return MachineManagementServiceApiFp(this.configuration).machineManagementServiceListMachinesOnlineStatus(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List motor couplings
     * @param {string} vmid vmid, aka vending machine uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineManagementServiceApi
     */
    public machineManagementServiceListMotorCouplings(vmid: string, options?: AxiosRequestConfig) {
        return MachineManagementServiceApiFp(this.configuration).machineManagementServiceListMotorCouplings(vmid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get vending machine detail
     * @param {string} vmid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineManagementServiceApi
     */
    public machineManagementServiceMachineDetail(vmid: string, options?: AxiosRequestConfig) {
        return MachineManagementServiceApiFp(this.configuration).machineManagementServiceMachineDetail(vmid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  Reset current vend delay period
     * @param {V1ResetVendDelayPeriodRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineManagementServiceApi
     */
    public machineManagementServiceResetVendDelayPeriod(body: V1ResetVendDelayPeriodRequest, options?: AxiosRequestConfig) {
        return MachineManagementServiceApiFp(this.configuration).machineManagementServiceResetVendDelayPeriod(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  RestartMachine to system 
     * @param {V1RestartMachineRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineManagementServiceApi
     */
    public machineManagementServiceRestartMachine(body: V1RestartMachineRequest, options?: AxiosRequestConfig) {
        return MachineManagementServiceApiFp(this.configuration).machineManagementServiceRestartMachine(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary send event to vending machine
     * @param {string} vmid 
     * @param {MachineManagementServiceSendEventToMachineRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineManagementServiceApi
     */
    public machineManagementServiceSendEventToMachine(vmid: string, body: MachineManagementServiceSendEventToMachineRequest, options?: AxiosRequestConfig) {
        return MachineManagementServiceApiFp(this.configuration).machineManagementServiceSendEventToMachine(vmid, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update belts couplings
     * @param {string} vmid vmid, aka vending machine uuid
     * @param {MachineManagementServiceUpdateBeltsCouplingsRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineManagementServiceApi
     */
    public machineManagementServiceUpdateBeltsCouplings(vmid: string, body: MachineManagementServiceUpdateBeltsCouplingsRequest, options?: AxiosRequestConfig) {
        return MachineManagementServiceApiFp(this.configuration).machineManagementServiceUpdateBeltsCouplings(vmid, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update vending machine
     * @param {string} vmid 
     * @param {MachineManagementServiceUpdateMachineRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineManagementServiceApi
     */
    public machineManagementServiceUpdateMachine(vmid: string, body: MachineManagementServiceUpdateMachineRequest, options?: AxiosRequestConfig) {
        return MachineManagementServiceApiFp(this.configuration).machineManagementServiceUpdateMachine(vmid, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update machine attributes
     * @param {string} vmid 
     * @param {ProductServiceUpdateProductAttributesRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineManagementServiceApi
     */
    public machineManagementServiceUpdateMachineAttributes(vmid: string, body: ProductServiceUpdateProductAttributesRequest, options?: AxiosRequestConfig) {
        return MachineManagementServiceApiFp(this.configuration).machineManagementServiceUpdateMachineAttributes(vmid, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update vending machine blackout period
     * @param {string} vmid 
     * @param {MachineManagementServiceUpdateMachineBlackoutPeriodRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineManagementServiceApi
     */
    public machineManagementServiceUpdateMachineBlackoutPeriod(vmid: string, body: MachineManagementServiceUpdateMachineBlackoutPeriodRequest, options?: AxiosRequestConfig) {
        return MachineManagementServiceApiFp(this.configuration).machineManagementServiceUpdateMachineBlackoutPeriod(vmid, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update motor couplings
     * @param {string} vmid vmid, aka vending machine uuid
     * @param {MachineManagementServiceUpdateMotorCouplingsRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineManagementServiceApi
     */
    public machineManagementServiceUpdateMotorCouplings(vmid: string, body: MachineManagementServiceUpdateMotorCouplingsRequest, options?: AxiosRequestConfig) {
        return MachineManagementServiceApiFp(this.configuration).machineManagementServiceUpdateMotorCouplings(vmid, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  Update vend delay settings for the vending machine 
     * @param {V1UpdateVendDelayRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineManagementServiceApi
     */
    public machineManagementServiceUpdateVendDelay(body: V1UpdateVendDelayRequest, options?: AxiosRequestConfig) {
        return MachineManagementServiceApiFp(this.configuration).machineManagementServiceUpdateVendDelay(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MediaManagementServiceApi - axios parameter creator
 * @export
 */
export const MediaManagementServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary add ScreenSaver to system  
         * @param {V1AddScreenSaverRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mediaManagementServiceAddScreenSaver: async (body: V1AddScreenSaverRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('mediaManagementServiceAddScreenSaver', 'body', body)
            const localVarPath = `/api-ng/telemetry/vending_machine/v1/screen_saver/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary delete  ScreenSavers to system 
         * @param {V1DeleteScreenSaverRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mediaManagementServiceDeleteScreenSaver: async (body: V1DeleteScreenSaverRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('mediaManagementServiceDeleteScreenSaver', 'body', body)
            const localVarPath = `/api-ng/telemetry/vending_machine/v1/screen_saver/del`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary show ScreenSavers list 
         * @param {TelemetryvendingMachinev1ListScreenSaversRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mediaManagementServiceListScreenSavers: async (body: TelemetryvendingMachinev1ListScreenSaversRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('mediaManagementServiceListScreenSavers', 'body', body)
            const localVarPath = `/api-ng/telemetry/vending_machine/v1/screen_savers/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update ScreenSavers
         * @param {string} screenSaverUuid 
         * @param {MediaManagementServiceUpdateScreenSaverRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mediaManagementServiceUpdateScreenSaver: async (screenSaverUuid: string, body: MediaManagementServiceUpdateScreenSaverRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'screenSaverUuid' is not null or undefined
            assertParamExists('mediaManagementServiceUpdateScreenSaver', 'screenSaverUuid', screenSaverUuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('mediaManagementServiceUpdateScreenSaver', 'body', body)
            const localVarPath = `/api-ng/telemetry/vending_machine/v1/screen_saver/{screenSaverUuid}/update`
                .replace(`{${"screenSaverUuid"}}`, encodeURIComponent(String(screenSaverUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MediaManagementServiceApi - functional programming interface
 * @export
 */
export const MediaManagementServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MediaManagementServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary add ScreenSaver to system  
         * @param {V1AddScreenSaverRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mediaManagementServiceAddScreenSaver(body: V1AddScreenSaverRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AddScreenSaverResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mediaManagementServiceAddScreenSaver(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary delete  ScreenSavers to system 
         * @param {V1DeleteScreenSaverRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mediaManagementServiceDeleteScreenSaver(body: V1DeleteScreenSaverRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mediaManagementServiceDeleteScreenSaver(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary show ScreenSavers list 
         * @param {TelemetryvendingMachinev1ListScreenSaversRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mediaManagementServiceListScreenSavers(body: TelemetryvendingMachinev1ListScreenSaversRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TelemetryvendingMachinev1ListScreenSaversResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mediaManagementServiceListScreenSavers(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary update ScreenSavers
         * @param {string} screenSaverUuid 
         * @param {MediaManagementServiceUpdateScreenSaverRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mediaManagementServiceUpdateScreenSaver(screenSaverUuid: string, body: MediaManagementServiceUpdateScreenSaverRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mediaManagementServiceUpdateScreenSaver(screenSaverUuid, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MediaManagementServiceApi - factory interface
 * @export
 */
export const MediaManagementServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MediaManagementServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary add ScreenSaver to system  
         * @param {V1AddScreenSaverRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mediaManagementServiceAddScreenSaver(body: V1AddScreenSaverRequest, options?: any): AxiosPromise<V1AddScreenSaverResponse> {
            return localVarFp.mediaManagementServiceAddScreenSaver(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary delete  ScreenSavers to system 
         * @param {V1DeleteScreenSaverRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mediaManagementServiceDeleteScreenSaver(body: V1DeleteScreenSaverRequest, options?: any): AxiosPromise<object> {
            return localVarFp.mediaManagementServiceDeleteScreenSaver(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary show ScreenSavers list 
         * @param {TelemetryvendingMachinev1ListScreenSaversRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mediaManagementServiceListScreenSavers(body: TelemetryvendingMachinev1ListScreenSaversRequest, options?: any): AxiosPromise<TelemetryvendingMachinev1ListScreenSaversResponse> {
            return localVarFp.mediaManagementServiceListScreenSavers(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update ScreenSavers
         * @param {string} screenSaverUuid 
         * @param {MediaManagementServiceUpdateScreenSaverRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mediaManagementServiceUpdateScreenSaver(screenSaverUuid: string, body: MediaManagementServiceUpdateScreenSaverRequest, options?: any): AxiosPromise<object> {
            return localVarFp.mediaManagementServiceUpdateScreenSaver(screenSaverUuid, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MediaManagementServiceApi - object-oriented interface
 * @export
 * @class MediaManagementServiceApi
 * @extends {BaseAPI}
 */
export class MediaManagementServiceApi extends BaseAPI {
    /**
     * 
     * @summary add ScreenSaver to system  
     * @param {V1AddScreenSaverRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaManagementServiceApi
     */
    public mediaManagementServiceAddScreenSaver(body: V1AddScreenSaverRequest, options?: AxiosRequestConfig) {
        return MediaManagementServiceApiFp(this.configuration).mediaManagementServiceAddScreenSaver(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary delete  ScreenSavers to system 
     * @param {V1DeleteScreenSaverRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaManagementServiceApi
     */
    public mediaManagementServiceDeleteScreenSaver(body: V1DeleteScreenSaverRequest, options?: AxiosRequestConfig) {
        return MediaManagementServiceApiFp(this.configuration).mediaManagementServiceDeleteScreenSaver(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary show ScreenSavers list 
     * @param {TelemetryvendingMachinev1ListScreenSaversRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaManagementServiceApi
     */
    public mediaManagementServiceListScreenSavers(body: TelemetryvendingMachinev1ListScreenSaversRequest, options?: AxiosRequestConfig) {
        return MediaManagementServiceApiFp(this.configuration).mediaManagementServiceListScreenSavers(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update ScreenSavers
     * @param {string} screenSaverUuid 
     * @param {MediaManagementServiceUpdateScreenSaverRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaManagementServiceApi
     */
    public mediaManagementServiceUpdateScreenSaver(screenSaverUuid: string, body: MediaManagementServiceUpdateScreenSaverRequest, options?: AxiosRequestConfig) {
        return MediaManagementServiceApiFp(this.configuration).mediaManagementServiceUpdateScreenSaver(screenSaverUuid, body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrganisationSettingsServiceApi - axios parameter creator
 * @export
 */
export const OrganisationSettingsServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Combo
         * @param {V1CreateComboRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organisationSettingsServiceCreateCombo: async (body: V1CreateComboRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('organisationSettingsServiceCreateCombo', 'body', body)
            const localVarPath = `/api-ng/telemetry/organisation/v1/combos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete combo
         * @param {string} comboUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organisationSettingsServiceDeleteCombo: async (comboUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'comboUuid' is not null or undefined
            assertParamExists('organisationSettingsServiceDeleteCombo', 'comboUuid', comboUuid)
            const localVarPath = `/api-ng/telemetry/organisation/v1/combos/{comboUuid}/delete`
                .replace(`{${"comboUuid"}}`, encodeURIComponent(String(comboUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get organisation settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organisationSettingsServiceGetOrganisationSettings: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api-ng/telemetry/organisation/v1/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List combos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organisationSettingsServiceListCombos: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api-ng/telemetry/organisation/v1/combos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update combo
         * @param {string} comboUuid 
         * @param {OrganisationSettingsServiceUpdateComboRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organisationSettingsServiceUpdateCombo: async (comboUuid: string, body: OrganisationSettingsServiceUpdateComboRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'comboUuid' is not null or undefined
            assertParamExists('organisationSettingsServiceUpdateCombo', 'comboUuid', comboUuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('organisationSettingsServiceUpdateCombo', 'body', body)
            const localVarPath = `/api-ng/telemetry/organisation/v1/combos/{comboUuid}`
                .replace(`{${"comboUuid"}}`, encodeURIComponent(String(comboUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update organisation settings
         * @param {V1UpdateOrganisationSettingsRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organisationSettingsServiceUpdateOrganisationSettings: async (body: V1UpdateOrganisationSettingsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('organisationSettingsServiceUpdateOrganisationSettings', 'body', body)
            const localVarPath = `/api-ng/telemetry/organisation/v1/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganisationSettingsServiceApi - functional programming interface
 * @export
 */
export const OrganisationSettingsServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganisationSettingsServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Combo
         * @param {V1CreateComboRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organisationSettingsServiceCreateCombo(body: V1CreateComboRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreateComboResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organisationSettingsServiceCreateCombo(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete combo
         * @param {string} comboUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organisationSettingsServiceDeleteCombo(comboUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organisationSettingsServiceDeleteCombo(comboUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get organisation settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organisationSettingsServiceGetOrganisationSettings(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetOrganisationSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organisationSettingsServiceGetOrganisationSettings(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List combos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organisationSettingsServiceListCombos(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TelemetryvendingMachinev1ListCombosResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organisationSettingsServiceListCombos(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update combo
         * @param {string} comboUuid 
         * @param {OrganisationSettingsServiceUpdateComboRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organisationSettingsServiceUpdateCombo(comboUuid: string, body: OrganisationSettingsServiceUpdateComboRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organisationSettingsServiceUpdateCombo(comboUuid, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update organisation settings
         * @param {V1UpdateOrganisationSettingsRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organisationSettingsServiceUpdateOrganisationSettings(body: V1UpdateOrganisationSettingsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organisationSettingsServiceUpdateOrganisationSettings(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganisationSettingsServiceApi - factory interface
 * @export
 */
export const OrganisationSettingsServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganisationSettingsServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Combo
         * @param {V1CreateComboRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organisationSettingsServiceCreateCombo(body: V1CreateComboRequest, options?: any): AxiosPromise<V1CreateComboResponse> {
            return localVarFp.organisationSettingsServiceCreateCombo(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete combo
         * @param {string} comboUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organisationSettingsServiceDeleteCombo(comboUuid: string, options?: any): AxiosPromise<object> {
            return localVarFp.organisationSettingsServiceDeleteCombo(comboUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get organisation settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organisationSettingsServiceGetOrganisationSettings(options?: any): AxiosPromise<V1GetOrganisationSettingsResponse> {
            return localVarFp.organisationSettingsServiceGetOrganisationSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List combos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organisationSettingsServiceListCombos(options?: any): AxiosPromise<TelemetryvendingMachinev1ListCombosResponse> {
            return localVarFp.organisationSettingsServiceListCombos(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update combo
         * @param {string} comboUuid 
         * @param {OrganisationSettingsServiceUpdateComboRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organisationSettingsServiceUpdateCombo(comboUuid: string, body: OrganisationSettingsServiceUpdateComboRequest, options?: any): AxiosPromise<object> {
            return localVarFp.organisationSettingsServiceUpdateCombo(comboUuid, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update organisation settings
         * @param {V1UpdateOrganisationSettingsRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organisationSettingsServiceUpdateOrganisationSettings(body: V1UpdateOrganisationSettingsRequest, options?: any): AxiosPromise<object> {
            return localVarFp.organisationSettingsServiceUpdateOrganisationSettings(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganisationSettingsServiceApi - object-oriented interface
 * @export
 * @class OrganisationSettingsServiceApi
 * @extends {BaseAPI}
 */
export class OrganisationSettingsServiceApi extends BaseAPI {
    /**
     * 
     * @summary Create Combo
     * @param {V1CreateComboRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationSettingsServiceApi
     */
    public organisationSettingsServiceCreateCombo(body: V1CreateComboRequest, options?: AxiosRequestConfig) {
        return OrganisationSettingsServiceApiFp(this.configuration).organisationSettingsServiceCreateCombo(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete combo
     * @param {string} comboUuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationSettingsServiceApi
     */
    public organisationSettingsServiceDeleteCombo(comboUuid: string, options?: AxiosRequestConfig) {
        return OrganisationSettingsServiceApiFp(this.configuration).organisationSettingsServiceDeleteCombo(comboUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get organisation settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationSettingsServiceApi
     */
    public organisationSettingsServiceGetOrganisationSettings(options?: AxiosRequestConfig) {
        return OrganisationSettingsServiceApiFp(this.configuration).organisationSettingsServiceGetOrganisationSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List combos
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationSettingsServiceApi
     */
    public organisationSettingsServiceListCombos(options?: AxiosRequestConfig) {
        return OrganisationSettingsServiceApiFp(this.configuration).organisationSettingsServiceListCombos(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update combo
     * @param {string} comboUuid 
     * @param {OrganisationSettingsServiceUpdateComboRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationSettingsServiceApi
     */
    public organisationSettingsServiceUpdateCombo(comboUuid: string, body: OrganisationSettingsServiceUpdateComboRequest, options?: AxiosRequestConfig) {
        return OrganisationSettingsServiceApiFp(this.configuration).organisationSettingsServiceUpdateCombo(comboUuid, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update organisation settings
     * @param {V1UpdateOrganisationSettingsRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationSettingsServiceApi
     */
    public organisationSettingsServiceUpdateOrganisationSettings(body: V1UpdateOrganisationSettingsRequest, options?: AxiosRequestConfig) {
        return OrganisationSettingsServiceApiFp(this.configuration).organisationSettingsServiceUpdateOrganisationSettings(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductServiceApi - axios parameter creator
 * @export
 */
export const ProductServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get product attributes
         * @param {string} productUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productServiceGetProductAttributes: async (productUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productUuid' is not null or undefined
            assertParamExists('productServiceGetProductAttributes', 'productUuid', productUuid)
            const localVarPath = `/api-ng/telemetry/product/v1/{productUuid}/attributes`
                .replace(`{${"productUuid"}}`, encodeURIComponent(String(productUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update product attributes
         * @param {string} productUuid 
         * @param {ProductServiceUpdateProductAttributesRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productServiceUpdateProductAttributes: async (productUuid: string, body: ProductServiceUpdateProductAttributesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productUuid' is not null or undefined
            assertParamExists('productServiceUpdateProductAttributes', 'productUuid', productUuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('productServiceUpdateProductAttributes', 'body', body)
            const localVarPath = `/api-ng/telemetry/product/v1/{productUuid}/attributes`
                .replace(`{${"productUuid"}}`, encodeURIComponent(String(productUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductServiceApi - functional programming interface
 * @export
 */
export const ProductServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary get product attributes
         * @param {string} productUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productServiceGetProductAttributes(productUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetProductAttributesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productServiceGetProductAttributes(productUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary update product attributes
         * @param {string} productUuid 
         * @param {ProductServiceUpdateProductAttributesRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productServiceUpdateProductAttributes(productUuid: string, body: ProductServiceUpdateProductAttributesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productServiceUpdateProductAttributes(productUuid, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductServiceApi - factory interface
 * @export
 */
export const ProductServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary get product attributes
         * @param {string} productUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productServiceGetProductAttributes(productUuid: string, options?: any): AxiosPromise<V1GetProductAttributesResponse> {
            return localVarFp.productServiceGetProductAttributes(productUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update product attributes
         * @param {string} productUuid 
         * @param {ProductServiceUpdateProductAttributesRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productServiceUpdateProductAttributes(productUuid: string, body: ProductServiceUpdateProductAttributesRequest, options?: any): AxiosPromise<object> {
            return localVarFp.productServiceUpdateProductAttributes(productUuid, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductServiceApi - object-oriented interface
 * @export
 * @class ProductServiceApi
 * @extends {BaseAPI}
 */
export class ProductServiceApi extends BaseAPI {
    /**
     * 
     * @summary get product attributes
     * @param {string} productUuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductServiceApi
     */
    public productServiceGetProductAttributes(productUuid: string, options?: AxiosRequestConfig) {
        return ProductServiceApiFp(this.configuration).productServiceGetProductAttributes(productUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update product attributes
     * @param {string} productUuid 
     * @param {ProductServiceUpdateProductAttributesRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductServiceApi
     */
    public productServiceUpdateProductAttributes(productUuid: string, body: ProductServiceUpdateProductAttributesRequest, options?: AxiosRequestConfig) {
        return ProductServiceApiFp(this.configuration).productServiceUpdateProductAttributes(productUuid, body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * S3ServiceApi - axios parameter creator
 * @export
 */
export const S3ServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get s3 path info
         * @param {string} [extension] extension of the file to be uploaded, e.g. \&quot;png\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        s3ServiceGetS3UploadPath: async (extension?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api-ng/telemetry/s3/upload/path`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (extension !== undefined) {
                localVarQueryParameter['extension'] = extension;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * S3ServiceApi - functional programming interface
 * @export
 */
export const S3ServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = S3ServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary get s3 path info
         * @param {string} [extension] extension of the file to be uploaded, e.g. \&quot;png\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async s3ServiceGetS3UploadPath(extension?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetS3UploadPathResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.s3ServiceGetS3UploadPath(extension, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * S3ServiceApi - factory interface
 * @export
 */
export const S3ServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = S3ServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary get s3 path info
         * @param {string} [extension] extension of the file to be uploaded, e.g. \&quot;png\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        s3ServiceGetS3UploadPath(extension?: string, options?: any): AxiosPromise<V1GetS3UploadPathResponse> {
            return localVarFp.s3ServiceGetS3UploadPath(extension, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * S3ServiceApi - object-oriented interface
 * @export
 * @class S3ServiceApi
 * @extends {BaseAPI}
 */
export class S3ServiceApi extends BaseAPI {
    /**
     * 
     * @summary get s3 path info
     * @param {string} [extension] extension of the file to be uploaded, e.g. \&quot;png\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof S3ServiceApi
     */
    public s3ServiceGetS3UploadPath(extension?: string, options?: AxiosRequestConfig) {
        return S3ServiceApiFp(this.configuration).s3ServiceGetS3UploadPath(extension, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VendingMachineGroupServiceApi - axios parameter creator
 * @export
 */
export const VendingMachineGroupServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create group combo
         * @param {string} groupUuid 
         * @param {VendingMachineGroupServiceCreateGroupComboRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingMachineGroupServiceCreateGroupCombo: async (groupUuid: string, body: VendingMachineGroupServiceCreateGroupComboRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupUuid' is not null or undefined
            assertParamExists('vendingMachineGroupServiceCreateGroupCombo', 'groupUuid', groupUuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('vendingMachineGroupServiceCreateGroupCombo', 'body', body)
            const localVarPath = `/api-ng/telemetry/vending_machine_group/v1/{groupUuid}/combos`
                .replace(`{${"groupUuid"}}`, encodeURIComponent(String(groupUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete group combo
         * @param {string} groupComboUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingMachineGroupServiceDeleteGroupCombo: async (groupComboUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupComboUuid' is not null or undefined
            assertParamExists('vendingMachineGroupServiceDeleteGroupCombo', 'groupComboUuid', groupComboUuid)
            const localVarPath = `/api-ng/telemetry/vending_machine_group/v1/combos/{groupComboUuid}/delete`
                .replace(`{${"groupComboUuid"}}`, encodeURIComponent(String(groupComboUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get vending machine group info
         * @param {string} groupUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingMachineGroupServiceGetVendingMachineGroupInfo: async (groupUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupUuid' is not null or undefined
            assertParamExists('vendingMachineGroupServiceGetVendingMachineGroupInfo', 'groupUuid', groupUuid)
            const localVarPath = `/api-ng/telemetry/vending_machine_group/v1/{groupUuid}`
                .replace(`{${"groupUuid"}}`, encodeURIComponent(String(groupUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List group combos
         * @param {string} groupUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingMachineGroupServiceListGroupCombos: async (groupUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupUuid' is not null or undefined
            assertParamExists('vendingMachineGroupServiceListGroupCombos', 'groupUuid', groupUuid)
            const localVarPath = `/api-ng/telemetry/vending_machine_group/v1/{groupUuid}/combos`
                .replace(`{${"groupUuid"}}`, encodeURIComponent(String(groupUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update group combo
         * @param {string} groupComboUuid 
         * @param {VendingMachineGroupServiceUpdateGroupComboRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingMachineGroupServiceUpdateGroupCombo: async (groupComboUuid: string, body: VendingMachineGroupServiceUpdateGroupComboRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupComboUuid' is not null or undefined
            assertParamExists('vendingMachineGroupServiceUpdateGroupCombo', 'groupComboUuid', groupComboUuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('vendingMachineGroupServiceUpdateGroupCombo', 'body', body)
            const localVarPath = `/api-ng/telemetry/vending_machine_group/v1/combos/{groupComboUuid}`
                .replace(`{${"groupComboUuid"}}`, encodeURIComponent(String(groupComboUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update vending machine group
         * @param {string} groupUuid 
         * @param {VendingMachineGroupServiceUpdateVendingMachineGroupRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingMachineGroupServiceUpdateVendingMachineGroup: async (groupUuid: string, body: VendingMachineGroupServiceUpdateVendingMachineGroupRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupUuid' is not null or undefined
            assertParamExists('vendingMachineGroupServiceUpdateVendingMachineGroup', 'groupUuid', groupUuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('vendingMachineGroupServiceUpdateVendingMachineGroup', 'body', body)
            const localVarPath = `/api-ng/telemetry/vending_machine_group/v1/{groupUuid}/update`
                .replace(`{${"groupUuid"}}`, encodeURIComponent(String(groupUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VendingMachineGroupServiceApi - functional programming interface
 * @export
 */
export const VendingMachineGroupServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VendingMachineGroupServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create group combo
         * @param {string} groupUuid 
         * @param {VendingMachineGroupServiceCreateGroupComboRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vendingMachineGroupServiceCreateGroupCombo(groupUuid: string, body: VendingMachineGroupServiceCreateGroupComboRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreateGroupComboResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vendingMachineGroupServiceCreateGroupCombo(groupUuid, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete group combo
         * @param {string} groupComboUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vendingMachineGroupServiceDeleteGroupCombo(groupComboUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vendingMachineGroupServiceDeleteGroupCombo(groupComboUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get vending machine group info
         * @param {string} groupUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vendingMachineGroupServiceGetVendingMachineGroupInfo(groupUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetVendingMachineGroupInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vendingMachineGroupServiceGetVendingMachineGroupInfo(groupUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List group combos
         * @param {string} groupUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vendingMachineGroupServiceListGroupCombos(groupUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListGroupCombosResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vendingMachineGroupServiceListGroupCombos(groupUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update group combo
         * @param {string} groupComboUuid 
         * @param {VendingMachineGroupServiceUpdateGroupComboRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vendingMachineGroupServiceUpdateGroupCombo(groupComboUuid: string, body: VendingMachineGroupServiceUpdateGroupComboRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vendingMachineGroupServiceUpdateGroupCombo(groupComboUuid, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update vending machine group
         * @param {string} groupUuid 
         * @param {VendingMachineGroupServiceUpdateVendingMachineGroupRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vendingMachineGroupServiceUpdateVendingMachineGroup(groupUuid: string, body: VendingMachineGroupServiceUpdateVendingMachineGroupRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vendingMachineGroupServiceUpdateVendingMachineGroup(groupUuid, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VendingMachineGroupServiceApi - factory interface
 * @export
 */
export const VendingMachineGroupServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VendingMachineGroupServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary Create group combo
         * @param {string} groupUuid 
         * @param {VendingMachineGroupServiceCreateGroupComboRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingMachineGroupServiceCreateGroupCombo(groupUuid: string, body: VendingMachineGroupServiceCreateGroupComboRequest, options?: any): AxiosPromise<V1CreateGroupComboResponse> {
            return localVarFp.vendingMachineGroupServiceCreateGroupCombo(groupUuid, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete group combo
         * @param {string} groupComboUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingMachineGroupServiceDeleteGroupCombo(groupComboUuid: string, options?: any): AxiosPromise<object> {
            return localVarFp.vendingMachineGroupServiceDeleteGroupCombo(groupComboUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get vending machine group info
         * @param {string} groupUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingMachineGroupServiceGetVendingMachineGroupInfo(groupUuid: string, options?: any): AxiosPromise<V1GetVendingMachineGroupInfoResponse> {
            return localVarFp.vendingMachineGroupServiceGetVendingMachineGroupInfo(groupUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List group combos
         * @param {string} groupUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingMachineGroupServiceListGroupCombos(groupUuid: string, options?: any): AxiosPromise<V1ListGroupCombosResponse> {
            return localVarFp.vendingMachineGroupServiceListGroupCombos(groupUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update group combo
         * @param {string} groupComboUuid 
         * @param {VendingMachineGroupServiceUpdateGroupComboRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingMachineGroupServiceUpdateGroupCombo(groupComboUuid: string, body: VendingMachineGroupServiceUpdateGroupComboRequest, options?: any): AxiosPromise<object> {
            return localVarFp.vendingMachineGroupServiceUpdateGroupCombo(groupComboUuid, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update vending machine group
         * @param {string} groupUuid 
         * @param {VendingMachineGroupServiceUpdateVendingMachineGroupRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingMachineGroupServiceUpdateVendingMachineGroup(groupUuid: string, body: VendingMachineGroupServiceUpdateVendingMachineGroupRequest, options?: any): AxiosPromise<object> {
            return localVarFp.vendingMachineGroupServiceUpdateVendingMachineGroup(groupUuid, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VendingMachineGroupServiceApi - object-oriented interface
 * @export
 * @class VendingMachineGroupServiceApi
 * @extends {BaseAPI}
 */
export class VendingMachineGroupServiceApi extends BaseAPI {
    /**
     * 
     * @summary Create group combo
     * @param {string} groupUuid 
     * @param {VendingMachineGroupServiceCreateGroupComboRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendingMachineGroupServiceApi
     */
    public vendingMachineGroupServiceCreateGroupCombo(groupUuid: string, body: VendingMachineGroupServiceCreateGroupComboRequest, options?: AxiosRequestConfig) {
        return VendingMachineGroupServiceApiFp(this.configuration).vendingMachineGroupServiceCreateGroupCombo(groupUuid, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete group combo
     * @param {string} groupComboUuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendingMachineGroupServiceApi
     */
    public vendingMachineGroupServiceDeleteGroupCombo(groupComboUuid: string, options?: AxiosRequestConfig) {
        return VendingMachineGroupServiceApiFp(this.configuration).vendingMachineGroupServiceDeleteGroupCombo(groupComboUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get vending machine group info
     * @param {string} groupUuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendingMachineGroupServiceApi
     */
    public vendingMachineGroupServiceGetVendingMachineGroupInfo(groupUuid: string, options?: AxiosRequestConfig) {
        return VendingMachineGroupServiceApiFp(this.configuration).vendingMachineGroupServiceGetVendingMachineGroupInfo(groupUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List group combos
     * @param {string} groupUuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendingMachineGroupServiceApi
     */
    public vendingMachineGroupServiceListGroupCombos(groupUuid: string, options?: AxiosRequestConfig) {
        return VendingMachineGroupServiceApiFp(this.configuration).vendingMachineGroupServiceListGroupCombos(groupUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update group combo
     * @param {string} groupComboUuid 
     * @param {VendingMachineGroupServiceUpdateGroupComboRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendingMachineGroupServiceApi
     */
    public vendingMachineGroupServiceUpdateGroupCombo(groupComboUuid: string, body: VendingMachineGroupServiceUpdateGroupComboRequest, options?: AxiosRequestConfig) {
        return VendingMachineGroupServiceApiFp(this.configuration).vendingMachineGroupServiceUpdateGroupCombo(groupComboUuid, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update vending machine group
     * @param {string} groupUuid 
     * @param {VendingMachineGroupServiceUpdateVendingMachineGroupRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendingMachineGroupServiceApi
     */
    public vendingMachineGroupServiceUpdateVendingMachineGroup(groupUuid: string, body: VendingMachineGroupServiceUpdateVendingMachineGroupRequest, options?: AxiosRequestConfig) {
        return VendingMachineGroupServiceApiFp(this.configuration).vendingMachineGroupServiceUpdateVendingMachineGroup(groupUuid, body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VmcpOrderServiceApi - axios parameter creator
 * @export
 */
export const VmcpOrderServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get vmcp order detail
         * @param {string} orderUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vmcpOrderServiceGetVmcpOrderDetail: async (orderUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderUuid' is not null or undefined
            assertParamExists('vmcpOrderServiceGetVmcpOrderDetail', 'orderUuid', orderUuid)
            const localVarPath = `/api-ng/telemetry/vmcp_order/v1/{orderUuid}`
                .replace(`{${"orderUuid"}}`, encodeURIComponent(String(orderUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list payment events
         * @param {number} [page] current page num
         * @param {number} [perPage] display the number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vmcpOrderServiceListPaymentEvents: async (page?: number, perPage?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api-ng/telemetry/vmcp_order/v1/payment/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['perPage'] = perPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary search order by xendit receipt id
         * @param {string} [xenditReceiptId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vmcpOrderServiceSearchOrderByReceiptId: async (xenditReceiptId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api-ng/telemetry/vmcp_order/v1/search-xendit-receipt-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xenditReceiptId !== undefined) {
                localVarQueryParameter['xenditReceiptId'] = xenditReceiptId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary search payment events
         * @param {number} [page] current page num
         * @param {number} [perPage] display the number of items per page
         * @param {string} [receiptId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vmcpOrderServiceSearchPaymentEvents: async (page?: number, perPage?: number, receiptId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api-ng/telemetry/vmcp_order/v1/search/payment/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['perPage'] = perPage;
            }

            if (receiptId !== undefined) {
                localVarQueryParameter['receiptId'] = receiptId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VmcpOrderServiceApi - functional programming interface
 * @export
 */
export const VmcpOrderServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VmcpOrderServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary get vmcp order detail
         * @param {string} orderUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vmcpOrderServiceGetVmcpOrderDetail(orderUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetVmcpOrderDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vmcpOrderServiceGetVmcpOrderDetail(orderUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary list payment events
         * @param {number} [page] current page num
         * @param {number} [perPage] display the number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vmcpOrderServiceListPaymentEvents(page?: number, perPage?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListPaymentEventsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vmcpOrderServiceListPaymentEvents(page, perPage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary search order by xendit receipt id
         * @param {string} [xenditReceiptId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vmcpOrderServiceSearchOrderByReceiptId(xenditReceiptId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1SearchOrderByReceiptIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vmcpOrderServiceSearchOrderByReceiptId(xenditReceiptId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary search payment events
         * @param {number} [page] current page num
         * @param {number} [perPage] display the number of items per page
         * @param {string} [receiptId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vmcpOrderServiceSearchPaymentEvents(page?: number, perPage?: number, receiptId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1SearchPaymentEventsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vmcpOrderServiceSearchPaymentEvents(page, perPage, receiptId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VmcpOrderServiceApi - factory interface
 * @export
 */
export const VmcpOrderServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VmcpOrderServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary get vmcp order detail
         * @param {string} orderUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vmcpOrderServiceGetVmcpOrderDetail(orderUuid: string, options?: any): AxiosPromise<V1GetVmcpOrderDetailResponse> {
            return localVarFp.vmcpOrderServiceGetVmcpOrderDetail(orderUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list payment events
         * @param {number} [page] current page num
         * @param {number} [perPage] display the number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vmcpOrderServiceListPaymentEvents(page?: number, perPage?: number, options?: any): AxiosPromise<V1ListPaymentEventsResponse> {
            return localVarFp.vmcpOrderServiceListPaymentEvents(page, perPage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary search order by xendit receipt id
         * @param {string} [xenditReceiptId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vmcpOrderServiceSearchOrderByReceiptId(xenditReceiptId?: string, options?: any): AxiosPromise<V1SearchOrderByReceiptIdResponse> {
            return localVarFp.vmcpOrderServiceSearchOrderByReceiptId(xenditReceiptId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary search payment events
         * @param {number} [page] current page num
         * @param {number} [perPage] display the number of items per page
         * @param {string} [receiptId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vmcpOrderServiceSearchPaymentEvents(page?: number, perPage?: number, receiptId?: string, options?: any): AxiosPromise<V1SearchPaymentEventsResponse> {
            return localVarFp.vmcpOrderServiceSearchPaymentEvents(page, perPage, receiptId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VmcpOrderServiceApi - object-oriented interface
 * @export
 * @class VmcpOrderServiceApi
 * @extends {BaseAPI}
 */
export class VmcpOrderServiceApi extends BaseAPI {
    /**
     * 
     * @summary get vmcp order detail
     * @param {string} orderUuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VmcpOrderServiceApi
     */
    public vmcpOrderServiceGetVmcpOrderDetail(orderUuid: string, options?: AxiosRequestConfig) {
        return VmcpOrderServiceApiFp(this.configuration).vmcpOrderServiceGetVmcpOrderDetail(orderUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list payment events
     * @param {number} [page] current page num
     * @param {number} [perPage] display the number of items per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VmcpOrderServiceApi
     */
    public vmcpOrderServiceListPaymentEvents(page?: number, perPage?: number, options?: AxiosRequestConfig) {
        return VmcpOrderServiceApiFp(this.configuration).vmcpOrderServiceListPaymentEvents(page, perPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary search order by xendit receipt id
     * @param {string} [xenditReceiptId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VmcpOrderServiceApi
     */
    public vmcpOrderServiceSearchOrderByReceiptId(xenditReceiptId?: string, options?: AxiosRequestConfig) {
        return VmcpOrderServiceApiFp(this.configuration).vmcpOrderServiceSearchOrderByReceiptId(xenditReceiptId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary search payment events
     * @param {number} [page] current page num
     * @param {number} [perPage] display the number of items per page
     * @param {string} [receiptId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VmcpOrderServiceApi
     */
    public vmcpOrderServiceSearchPaymentEvents(page?: number, perPage?: number, receiptId?: string, options?: AxiosRequestConfig) {
        return VmcpOrderServiceApiFp(this.configuration).vmcpOrderServiceSearchPaymentEvents(page, perPage, receiptId, options).then((request) => request(this.axios, this.basePath));
    }
}


